/** #1212: bounded, in-memory request attribution. Never records URLs, tokens,
 * tickers, account data or stack traces. A send is not proof of replay completion. */
export const SNAPSHOT_TRACE_LIMIT = 32;
export const SNAPSHOT_REASONS = [
  'unspecified', 'subscription', 'toolbar-stale-population', 'visibility-stale',
  'watchdog-stale', 'ownership-takeover', 'announce-gained', 'announce-lost',
  'venue-fallback', 'directory-change', 'feed-disconnected', 'healthy-reconnect',
  'props-open', 'odds-recovery',
] as const;
export type SnapshotReason = typeof SNAPSHOT_REASONS[number];
export function snapshotReason(value: unknown): SnapshotReason {
  return SNAPSHOT_REASONS.includes(value as SnapshotReason) ? value as SnapshotReason : 'unspecified';
}
export interface SnapshotTrace {
  atMs: number;
  operation: 'snapshot' | 'subscribe';
  channel: 'markets' | 'oddspapi';
  reason: SnapshotReason;
  requester: string;
  /** Installed fence at send time, not the generation a pending subscribe will receive. */
  socketIncarnation: string | null;
  filterGeneration: number | null;
}
export class SnapshotTraceBuffer {
  private entries: SnapshotTrace[] = [];
  add(entry: SnapshotTrace): void {
    this.entries.push(entry);
    if (this.entries.length > SNAPSHOT_TRACE_LIMIT) this.entries.shift();
  }
  read(): readonly SnapshotTrace[] { return this.entries.slice(); }
  replace(entries: readonly SnapshotTrace[]): void { this.entries = entries.slice(-SNAPSHOT_TRACE_LIMIT); }
}
